import styled from "styled-components";
import { useRssProviderData } from "../hooks/useRssProviderData";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => `0 ${theme.space[3]}`};
`;

const HighlightsWrapper = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space[3]};
  grid-template-columns: 1fr;
  align-items: stretch;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  }
`;

// const StyledLink = styled.a`
//   text-decoration: none;
// `;

const StyledHeroCard = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.greyDarker4};
  background-size: contain;
  border-radius: ${({ theme }) => theme.radii[2]};
`;
const StyledImg = styled.img`
  width: 100%;
  object-fit: cover;
  border-top-left-radius: ${({ theme }) => theme.radii[2]};
  border-top-right-radius: ${({ theme }) => theme.radii[2]};
`;

const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.greyDarker4};
  border-radius: ${({ theme }) => theme.radii[2]};
`;

const Title = styled.h3`
  width: 100%;
  margin: ${({ theme }) => `0 0 ${theme.space[3]}`};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 1.25em;
`;

const Desc = styled.div`
  margin-top: 0;
  padding-bottom: ${({ theme }) => theme.space[4]};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  color: ${({ theme }) => theme.colors.black};
  line-height: normal;
`;

interface Props {
  url: string;
  link: string;
  numberOfArticles: number;
}

const BodyContent = styled.div`
  padding: ${({ theme }) => `${theme.space[2]}  ${theme.space[4]} 0`};
`;

const HeroProvider = ({ url, numberOfArticles }: Props) => {
  const { providerData } = useRssProviderData({
    url,
    numberOfArticles,
  });

  if (!providerData) {
    return null;
  }

  return (
    <Container>
      <HighlightsWrapper>
        {providerData.map((item) => {
          return (
            <div key={item.link}>
              {/* <StyledLink
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                role="link"
              > */}
              <StyledHeroCard>
                <Content>
                  {item.enclosure && (
                    <StyledImg
                      src={item.enclosure.url}
                      alt=""
                      aria-hidden="true"
                    />
                  )}
                  <BodyContent>
                    <Title>{item.title}</Title>
                    <Desc>{item.content}</Desc>
                  </BodyContent>
                </Content>
              </StyledHeroCard>
              {/* </StyledLink> */}
            </div>
          );
        })}
      </HighlightsWrapper>
    </Container>
  );
};

export default HeroProvider;
